import $ from "jquery";

import "jquery-touchswipe";
import { scrollToFocuse } from "../../Layout/Common/common";
import { excludeTechnicalKeywords } from "../../constants";

export function loadImageouchScriptNew(root = document) {
  const $root = $(root);
  try {
    $root.find(".productGallery").off("mouseenter mouseleave");
    $root.find(".productGallery").css("transform", "none");

    $(window).off("resize.productGallery").on("resize.productGallery", function () {
      $root.find(".productGallery").off("mouseenter mouseleave").css("transform", "none");
    });

    // Rest of your code for handling image clicks and other interactions
    $root.find(".productGallery-small-img:first-of-type").css({
      border: "solid 1px #F82643",
      padding: "0px",
    });
    $root.find(".productGallery-small-img:first-of-type").attr("alt", "now").siblings().removeAttr("alt");

    $root.find(".productGallery-small-img").click(function () {
      const imgSrc = $(this).attr("src");
      $root.find("#productGallery-img").attr("src", imgSrc);
      $root.find("#productBig-img").attr("src", imgSrc);
      $(this).attr("alt", "now").siblings().removeAttr("alt");
      $(this).css({ border: "solid 1px #F82643", padding: "0px" }).siblings().css({ border: "none", padding: "0" });

      if ($root.find("#small-img-roll").children().length > 4) {
        if ($(this).index() >= 3 && $(this).index() < $root.find("#small-img-roll").children().length - 1) {
          $root.find("#small-img-roll").css("left", -($(this).index() - 2) * 100 + "px"); // Removed extra parenthesis
        } else if ($(this).index() == $root.find("#small-img-roll").children().length - 1) {
          // $("#small-img-roll").css(
          //   "left",
          //   -($("#small-img-roll").children().length - 4) * 1 + "px"
          // );
        } else {
          $root.find("#small-img-roll").css("left", "0");
        }
      }
    });

    $root.find("#next-img").click(function (event) {
      // Find the currently active small image
      var current = $root.find(".productGallery-small-img[alt='now']");
      var next = current.closest(".productGallery-small-img").next();

      if (next.length > 0) {
        // Update big image
        $root.find("#productGallery-img").attr("src", next.attr("src"));
        $root.find("#productBig-img").attr("src", next.attr("src"));

        // Update border and padding
        next.css({ border: "solid 1px #F82643", padding: "0px" });
        $root.find(".productGallery-small-img").not(next).css({ border: "none", padding: "0" });

        // Update 'now' alt attributes
        next.attr("alt", "now");
        $root.find(".productGallery-small-img").not(next).removeAttr("alt");

        // Move the thumbnail roll if needed
        if ($root.find("#small-img-roll").children().length > 4) {
          var index = next.closest(".productGallery-small-img").index();
          var total = $root.find("#small-img-roll").children().length;

          if (index >= 3 && index < total) {
            $root.find("#small-img-roll").css("left", -(index - 2) * 100 + "px");
          } else {
            $root.find("#small-img-roll").css("left", "0");
          }
        }
      }
    });

    $root.find("#prev-img").click(function (event) {
      var current = $root.find(".productGallery-small-img[alt='now']");
      var prev = current.closest(".productGallery-small-img").prev();

      if (prev.length > 0) {
        // Update big image
        $root.find("#productGallery-img").attr("src", prev.attr("src"));
        $root.find("#productBig-img").attr("src", prev.attr("src"));

        // Update border and padding
        prev.css({ border: "solid 1px #F82643", padding: "0px" });
        $root.find(".productGallery-small-img").not(prev).css({ border: "none", padding: "0" });

        // Update 'now' alt attributes
        prev.attr("alt", "now");
        $root.find(".productGallery-small-img").not(prev).removeAttr("alt");

        // Move the thumbnail roll if needed
        if ($root.find("#small-img-roll").children().length > 4) {
          var index = prev.closest(".productGallery-small-img").index();
          if (index >= 2) {
            $root.find("#small-img-roll").css("left", -(index - 2) * 100 + "px");
          } else {
            $root.find("#small-img-roll").css("left", "0");
          }
        }
      }
    });

    const currentPosition = 0;
    const scrollAmount = 76;
    const maxPosition = -($root.find("#small-img-roll").children().length - 4) * scrollAmount;

    // Swipe functionality for #small-img-roll and #productGallery-img
    if ($.fn.swipe) {
      $root.find("#small-img-roll, #productGallery-img").swipe({
        swipeLeft: function () {
          if (Math.abs(currentPosition) < Math.abs(maxPosition)) {
            $root.find("#next-img").trigger("click");
          }
        },
        swipeRight: function () {
          if (currentPosition < 0) {
            $root.find("#prev-img").trigger("click");
          }
        },
        threshold: 20,
      });

      // Add swipe functionality to the large image container
      $root.find("#productGallery-img").swipe({
        swipeLeft: function () {
          if (currentPosition > maxPosition) {
            $root.find("#next-img").trigger("click"); // Simulate next image click
          }
        },
        swipeRight: function () {
          if (currentPosition < 0) {
            $root.find("#prev-img").trigger("click"); // Simulate previous image click
          }
        },
        threshold: 20, // Minimum swipe distance
      });
    } else {
      console.error("Swipe plugin not loaded.");
    }

    // Next image button click handler
    // $("#next-img").click(function () {
    //   if (currentPosition > maxPosition) {
    //     currentPosition -= scrollAmount;
    //     $("#small-img-roll").css(
    //       "transform",
    //       `translateX(${currentPosition}px)`
    //     );
    //   } else {
    //     console.log("Last slide reached");
    //     // Optionally, add visual feedback here
    //   }
    // });

    // Previous image button click handler
    // $("#prev-img").click(function () {
    //   if (currentPosition < 0) {
    //     currentPosition += scrollAmount;
    //     $("#small-img-roll").css(
    //       "transform",
    //       `translateX(${currentPosition}px)`
    //     );
    //   } else {
    //     console.log("First slide reached");
    //     // Optionally, add visual feedback here
    //   }
    // });
  } catch (ex) {
    console.error("gallery", ex);
  }
}
export function bigImageScript(root = document) {
  const $root = $(root);
  var thumbContainer = $root.find(".popup-thumb-container");
  var scrollAmount = 100;
  var currentIndex = 0;
  var images = $root.find(".popupsmallImage");

  function updateBigContent(index) {
    currentIndex = index;
    var selectedImage = images.eq(index);
    var popupContent = $root.find("#popupContent");

    if (selectedImage.hasClass("video-thumb")) {
      // Handle YouTube Video
      var videoUrl = selectedImage.attr("data-video");
      popupContent.html(`<iframe width="100%" height="550" src="${videoUrl}" 
                             frameborder="0" allowfullscreen></iframe>`);
    } else {
      // Handle Image without Magnify
      var newImageUrl = selectedImage.attr("data-big");
      popupContent.html(`<img id="popupbigImage" src="${newImageUrl}" alt="Big Image">`);
    }
    images.removeClass("active");
    selectedImage.addClass("active");
    if ($(window).width() > 768) {
      // Desktop View (Vertical Scroll)
      var containerHeight = thumbContainer.height();
      const scrollPosition = thumbContainer.scrollTop();
      const activePosition = selectedImage.position().top + scrollPosition;
      thumbContainer.animate(
        {
          scrollTop: activePosition - containerHeight / 2 + selectedImage.height() / 2,
        },
        300,
      );
    } else {
      var containerWidth = thumbContainer.width();
      const scrollPosition = thumbContainer.scrollLeft();
      const activePosition = selectedImage.position().left + scrollPosition;
      thumbContainer.animate(
        {
          scrollLeft: activePosition - containerWidth / 2 + selectedImage.width() / 2,
        },
        300,
      );
    }
  }
  // Thumbnail Click Event
  $root.find(".popupsmallImage").click(function () {
    updateBigContent(images.index(this));
  });
  // Next/Prev Navigation
  $root.find(".popup-big-next").click(function () {
    currentIndex = (currentIndex + 1) % images.length;
    updateBigContent(currentIndex);
  });
  $root.find(".popup-big-prev").click(function () {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    updateBigContent(currentIndex);
  });
  // Next/Prev Thumbnail Scroll
  $root.find(".popup-thumb-next").click(function () {
    const l = images.length / 2;
    if (currentIndex < images.length - l) {
      currentIndex++;
      updateBigContent(currentIndex);
    }
    if ($(window).width() <= 768) {
      thumbContainer.animate({ scrollLeft: "+=" + scrollAmount }, 300);
    } else {
      thumbContainer.animate({ scrollTop: "+=" + scrollAmount }, 300);
    }
  });
  $root.find(".popup-thumb-prev").click(function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateBigContent(currentIndex);
    }
    if ($(window).width() <= 768) {
      thumbContainer.animate({ scrollLeft: "-=" + scrollAmount }, 300);
    } else {
      thumbContainer.animate({ scrollTop: "-=" + scrollAmount }, 300);
    }
  });
  // Touch Swipe Support
  let startX, scrollLeft, startY, scrollTop;
  thumbContainer.on("touchstart", function (e) {
    startX = e.originalEvent.touches[0].pageX;
    scrollLeft = thumbContainer.scrollLeft();
    startY = e.originalEvent.touches[0].pageY;
    scrollTop = thumbContainer.scrollTop();
  });
  thumbContainer.on("touchmove", function (e) {
    const moveX = e.originalEvent.touches[0].pageX;
    const moveY = e.originalEvent.touches[0].pageY;
    if ($(window).width() <= 768) {
      // Horizontal scroll on mobile
      thumbContainer.scrollLeft(scrollLeft + (startX - moveX));
    } else {
      // Vertical scroll on desktop
      thumbContainer.scrollTop(scrollTop + (startY - moveY));
    }
    e.preventDefault();
  });
}

export function loadScriptDropDown() {
  let _currentTarget;
  $(".proList-dropdown").click(function (event) {
    if (_currentTarget !== event.currentTarget) {
      _currentTarget = event.currentTarget;
      $(".proList-dropdown").removeClass("active");
      $(this).addClass("active");
    } else {
      $(event.currentTarget).on("hide.bs.dropdown", function (e) {
        e.preventDefault();
      });
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest(".proList-dropdown").length) {
      $(".proList-dropdown").removeClass("active");
    }
  });

  var $dropdowns = $(".proList-dropdown");
  $dropdowns.each(function () {
    var $dropdown = $(this);
    $dropdown.on("show.bs.dropdown", function () {
      $dropdowns.each(function () {
        var $otherDropdown = $(this);

        if ($otherDropdown[0] !== $dropdown[0]) {
          var $dropdownMenu = $otherDropdown.find(".dropdown-menu");
          if ($dropdownMenu.hasClass("show")) {
            $dropdownMenu.removeClass("show");
          }
        }
      });
    });
  });
}
export function stickyFunction() {
  try {
    let stickySection = $(".section-proDescription");
    let stickyOffset = stickySection.offset().top;
    let isScrolling = false;
    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
    // Function to handle scroll event
    const handleScroll = debounce(function () {
      if (isScrolling) return;
      stickySection = $(".section-proDescription");
      if ((stickySection && stickySection.length > 0) == false) {
        return;
      }
      stickyOffset = stickySection.offset().top;
      const scrollPosition = $(window).scrollTop();
      if (scrollPosition >= stickyOffset) {
        stickySection.addClass("sticky");
      } else {
        stickySection.removeClass("sticky");
      }
      $(".proSection-onPage ul li a").each(function () {
        var section = $(this).attr("href");
        if ($(section).offset()) {
          if (
            $(section).offset().top - 130 <= scrollPosition &&
            $(section).offset().top + $(section).outerHeight() > scrollPosition
          ) {
            $(".proSection-onPage ul li").removeClass("active");
            $(this).parent("li").addClass("active");
          }
        }
      });
    }, 100);
    $(window).on("scroll", handleScroll);
    $(".proSection-onPage ul li a").on("click", function (event) {
      event.preventDefault();
      let target = $(this).attr("href");
      let offsetTop = $(target).offset().top - 100;
      isScrolling = true;
      $("html, body").animate(
        {
          scrollTop: offsetTop,
        },
        200,
        "swing",
        function () {
          isScrolling = false;
        },
      );
      $(".proSection-onPage ul li").removeClass("active");
      $(this).parent("li").addClass("active");
    });
  } catch (ex) {
  }
}
export function toggleSections() {
  $("#proNo-downloads").slideToggle("slow");
  $("#listofProducts").slideToggle("slow");
}
export function pdfSendMailtoggleSections() {
  $("#proNo-downloads, #mailsentsuccess").slideToggle("slow");
  $("#requestDownloads").slideDown("slow");
  scrollToFocuse(document.getElementById("section-downloads"), 100);
}

export function askQuestionMailtoggleSections() {
  $("#askQuestionSuccess, #formAskQuestion").slideToggle("slow");
  scrollToFocuse(document.getElementById("askQuestionSuccess"), 100);
}
export function descriptionHasValue(params) {
  let isExists;
  try {
    if (!params) return false;
    isExists = !!(params.familyDesc || params.feature || params.specification);
    if (isExists === true) return true;
    if (params.isFamily === false && params.technicalData) {
      const techstr = params.technicalData.replace(/[\r\n]+/g, "\\n");
      const data = JSON.parse(techstr);
      const filtereddata = data.filter(
        (item) => !excludeTechnicalKeywords.some((keyword) => item.Attr_Name.includes(keyword)),
      );

      if (!filtereddata && !isExists) return false;
      else return true;
    }
  } catch (e) {
    console.error("fn:descriptionHasValue(params) " + e);
  }
  return isExists;
}
